exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v6otV18Xd1cWUycgvJNbM {\n  display: flex;\n  flex-flow: row wrap;\n  padding: 2rem;\n}\n", ""]);

// exports
exports.locals = {
	"active-cards": "v6otV18Xd1cWUycgvJNbM"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/active-cards.styl
 ** module id = 253
 ** module chunks = 0
 **/